import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { ROLES } from '../../data/recruitmentContent';
import { CheckCircle2, ListChecks, Wallet } from 'lucide-react';

export const RoleDetails = ({ slug }) => {
  const role = ROLES[slug];
  if (!role) return null;
  return (
    <div className="space-y-4" data-testid="role-details">
      {role.salary && (
        <div className="flex items-center gap-3 rounded-xl border border-green-200 bg-green-50 p-4" data-testid="role-salary">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center shrink-0"><Wallet size={20} className="text-green-700" /></div>
          <div>
            <p className="text-xs font-semibold text-green-800 uppercase tracking-wide">Retribuzione indicativa</p>
            <p className="text-lg font-bold text-green-900">{role.salary}</p>
            <p className="text-xs text-green-700/80">La cifra cresce con esperienza, attestati e inquadramento CCNL riconosciuto.</p>
          </div>
        </div>
      )}
      {role.note && !role.salary && (
        <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="role-note">
          <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center shrink-0"><Wallet size={18} className="text-amber-700" /></div>
          <p className="text-sm text-amber-900">{role.note}</p>
        </div>
      )}
      <div className="space-y-2">
        {role.intro.map((p, i) => (
          <p key={i} className="text-sm text-slate-600 leading-relaxed">{p}</p>
        ))}
      </div>
      <div>
        <div className="flex items-center gap-2 mb-2">
          <ListChecks size={18} className="text-[#1a4b8c]" />
          <h3 className="font-semibold text-slate-800">Descrizione dettagliata del ruolo</h3>
        </div>
        <Accordion type="single" collapsible className="rounded-xl border border-slate-200 bg-white px-4">
          {role.sections.map((s, i) => (
            <AccordionItem key={i} value={`s-${i}`}>
              <AccordionTrigger className="text-sm font-semibold text-left">{s.title}</AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-1.5">
                  {s.items.map((it, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-slate-600">
                      <CheckCircle2 size={15} className="text-[#1a4b8c] shrink-0 mt-0.5" /> <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};
